import Vue from 'vue'
import repository from '@/repositories/Repository'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.itemGroup) this.$itemGroup = options.itemGroup
    else if (options.parent && options.parent.$itemGroup)
      this.$itemGroup = options.parent.$itemGroup
  },
})

export default {
  async upload(company, file) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('company', company)

    try {
      const response = await repository.giggle.post(
        `/api/item/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )

      return response.data
    } catch (error) {
      if (error.response.status === 400) {
        return {
          invalidFile: true,
        }
      }
      throw error
    }
  },
}
